export default {
  strict: true,
  namespaced: true,
  state: {
    list: {},
    flights: []
  },
  mutations: {
    addAirlines (state, value) { state.list[value.id] = value.list },
    addFlights (state, value) { state.flights = value }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/airlines.js